import { useEffect } from 'react'
import UserPanel from './UserPanel'
import AdminPanel from './AdminPanel'
import { ROLES } from '../../config/user'
import { useHistory } from 'react-router'
import SuperUserPanel from './SuperUserPanel'
import BussinessPanel from './BussinessPanel'
import { useSession } from '../../context/SessionContext'

/**
 * Custom `DocEngine` component declaration.
 * Load AppBarr and redirect user
 * @return DocEngine
*/
const DocEngine = (): JSX.Element => {
  const history = useHistory();
  const { token, getUserData, user } = useSession()

  // load user data
  useEffect(() => {
    if (getUserData && token) getUserData()
  }, [])

  // redirect the user
  if (!token) {
    history.push('/login')
  }

  return (
    <div>
      {user?.role === ROLES.USER && <UserPanel />}
      {user?.role === ROLES.ADMIN && <AdminPanel />}
      {user?.role === ROLES.SUPER_USER && <SuperUserPanel />}
      {user?.role === ROLES.BUSSINESS && <BussinessPanel />}
    </div>
  )
}

export default DocEngine